import React from 'react'
import classNames from 'classnames'
import Field from '../Field'
import { twMerge } from 'tailwind-merge'

export const TextAreaElement = ({ innerRef, errors, className, ...props }) => (
  <textarea
    className={classNames(twMerge([
      'w-full',
      'p-4',
      'transition',
      'duration-200',
      'border',
      'peer',
    ], {
      xs:   'p-1',
      sm:   'p-1 sm:p-2',
      base: 'p-1 sm:p-2 md:p-4',
      lg:   'p-1 sm:p-2 md:p-4 lg:p-6',
    }[props.size] ?? '', {
      'border-gray-300 focus:border-primary': !errors.length,
      'border-negative': !!errors.length,
    }, className))}
    ref={innerRef}
    {...props}
  />
)

export const TextArea = (props) => (
  <Field {...props} element={TextAreaElement} />
)

export default TextArea
